(function () {
  "use strict";
  var R = (window.SABLE || {});
  var cartUrl = R.cartUrl || "/cart";
  var addUrl = R.addUrl || "/cart/add.js";

  function money(cents) {
    try { return (cents / 100).toLocaleString(undefined, { style: "currency", currency: R.currency || "USD" }); }
    catch (e) { return "$" + (cents / 100).toFixed(2); }
  }

  /* ---- mobile menu ---- */
  function menu() {
    var btn = document.querySelector(".hdr__menu");
    var scrim = document.querySelector(".menu-scrim");
    if (!btn) return;
    var toggle = function (open) { document.body.classList.toggle("menu-open", open); };
    btn.addEventListener("click", function () { toggle(!document.body.classList.contains("menu-open")); });
    if (scrim) scrim.addEventListener("click", function () { toggle(false); });
    var close = document.querySelector(".hdr__close");
    if (close) close.addEventListener("click", function () { toggle(false); });
  }

  /* ---- bag count ---- */
  function setBag(n) {
    document.querySelectorAll("[data-bag-count]").forEach(function (el) {
      el.textContent = n;
      el.style.transform = "scale(1.3)";
      setTimeout(function () { el.style.transform = "scale(1)"; }, 180);
    });
  }
  function refreshBag() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { setBag(c.item_count); }).catch(function () {});
  }

  /* ---- reveal (sections + staggered grids) ---- */
  function reveal() {
    var items = document.querySelectorAll("[data-reveal],[data-stagger]");
    if (!items.length) return;
    function show(el) {
      if (el.hasAttribute("data-stagger")) {
        var kids = el.children;
        for (var i = 0; i < kids.length; i++) { kids[i].style.transitionDelay = (Math.min(i, 11) * 70) + "ms"; }
      }
      el.classList.add("in");
    }
    if (!("IntersectionObserver" in window)) { items.forEach(show); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -7% 0px" });
    items.forEach(function (i) { io.observe(i); });
    // safety net: never leave content hidden if the observer is missed
    setTimeout(function () { items.forEach(show); }, 4000);
  }

  /* ---- header: condense + shadow once scrolled ---- */
  function headerScroll() {
    var hdr = document.querySelector(".hdr");
    if (!hdr) return;
    var ticking = false;
    function apply() { hdr.classList.toggle("hdr--scrolled", window.scrollY > 24); ticking = false; }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    apply();
  }

  /* ---- PDP ---- */
  function pdp() {
    var root = document.querySelector("[data-product]");
    if (!root) return;
    var data;
    try { data = JSON.parse(document.getElementById("ProductJSON").textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var optNames = data.options || [];
    var colorIdx = optNames.findIndex(function (n) { return /colou?r/i.test(n); });
    if (colorIdx < 0) colorIdx = 0;
    var selected = {};

    // default to first available variant's options
    var first = variants.find(function (v) { return v.available; }) || variants[0];
    if (first) optNames.forEach(function (name, i) { selected[i] = first.options[i]; });

    var priceEl = root.querySelector("[data-price]");
    var saveEl = root.querySelector("[data-save]");
    var idInput = root.querySelector("[data-variant-id]");
    var addBtn = root.querySelector("[data-add-btn]");
    var stickyBar = root.querySelector("[data-pdp-sticky]");
    var stickyAdd = root.querySelector("[data-sticky-add]");
    var stickyPrice = root.querySelector("[data-sticky-price]");

    function findVariant() {
      return variants.find(function (v) {
        return optNames.every(function (n, i) { return v.options[i] === selected[i]; });
      });
    }
    function colorAvailable(colorIdx, val) {
      // is there any available variant with this colour (option index colorIdx)
      return variants.some(function (v) { return v.options[colorIdx] === val && v.available; });
    }
    var thumbsEl = root.querySelector(".pdp__thumbs");
    var mainEl = root.querySelector(".pdp__main");
    var galleryEl = root.querySelector(".pdp__gallery");
    var pTitle = ((root.querySelector(".ptitle") || {}).textContent || "").trim().replace(/&/g, "&amp;").replace(/"/g, "&quot;");
    var colorImages = {};
    try { colorImages = JSON.parse(document.getElementById("ColorImagesJSON").textContent); } catch (e) {}
    // ---- per-colour circular video preview + fullscreen ----
    var colorVideos = {};
    try { colorVideos = JSON.parse(document.getElementById("ColorVideosJSON").textContent); } catch (e) {}
    // two rows of circles (desktop below the description, phone beside the price); only one shows per breakpoint, each holds one circle per tagged video
    var cvRows = [].slice.call(root.querySelectorAll("[data-cvrow]"));
    var cvModal = document.querySelector("[data-cvmodal]");
    var cvModalVid = cvModal ? cvModal.querySelector("[data-cvmodal-vid]") : null;
    function cvCircleHTML(item) {
      var p = item.p ? ' poster="' + item.p + '"' : '';
      return '<button type="button" class="cvbtn" data-cvbtn data-v="' + item.v + '"' + (item.p ? ' data-p="' + item.p + '"' : '') +
        ' aria-label="Watch product video"><span class="cvbtn__ring"><video class="cvbtn__vid" muted loop playsinline preload="metadata"' + p + '></video>' +
        '<span class="cvbtn__play" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span></span></button>';
    }
    function updateColorVideo() {
      if (!cvRows.length) return;
      var color = selected[colorIdx];
      var arr = colorVideos[color] || [];
      cvRows.forEach(function (row) {
        if (!arr.length) {
          row.hidden = true;
          if (row.getAttribute("data-color") !== "__none") { row.innerHTML = ""; row.setAttribute("data-color", "__none"); }
          return;
        }
        row.hidden = false;
        if (row.getAttribute("data-color") !== color) {
          row.setAttribute("data-color", color);
          var html = "";
          for (var i = 0; i < arr.length; i++) html += cvCircleHTML(arr[i]);
          row.innerHTML = html;
        }
        // load/play previews only in the row that's actually visible at this breakpoint
        if (row.offsetParent !== null) {
          var vids = row.querySelectorAll(".cvbtn__vid");
          for (var j = 0; j < vids.length; j++) {
            if (arr[j] && vids[j].getAttribute("src") !== arr[j].v) { vids[j].src = arr[j].v; vids[j].play().catch(function () {}); }
          }
        }
      });
    }
    if (cvRows.length && cvModal && cvModalVid) {
      function openVideo(btn) {
        var url = btn.getAttribute("data-v"); if (!url) return;
        var poster = btn.getAttribute("data-p");
        if (poster) cvModalVid.poster = poster; else cvModalVid.removeAttribute("poster");
        cvModalVid.src = url;
        cvModalVid.muted = true;
        cvModal.hidden = false;
        cvModal.setAttribute("aria-hidden", "false");
        cvModal.getBoundingClientRect(); // force layout so the transition runs
        requestAnimationFrame(function () {
          cvModal.classList.add("open");
          document.body.classList.add("cv-locked");
          cvModalVid.play().catch(function () {});
        });
      }
      cvRows.forEach(function (row) {
        row.addEventListener("click", function (e) { var btn = e.target.closest("[data-cvbtn]"); if (btn) openVideo(btn); });
      });
      var closeVideo = function () {
        cvModal.classList.remove("open");
        cvModal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("cv-locked");
        cvModalVid.pause();
        setTimeout(function () { cvModal.hidden = true; cvModalVid.removeAttribute("src"); if (cvModalVid.load) cvModalVid.load(); }, 480);
      };
      cvModal.addEventListener("click", function (e) {
        if (e.target === cvModal || e.target.closest("[data-cvclose]")) closeVideo();
      });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && cvModal.classList.contains("open")) closeVideo(); });
    }
    var lastColor = null;
    var slides = [];
    // Highlight the thumb for the slide currently in view.
    function setActiveThumb(i) {
      if (!thumbsEl) return;
      var btns = thumbsEl.querySelectorAll("button");
      for (var j = 0; j < btns.length; j++) btns[j].classList.toggle("on", j === i);
    }
    // Build the selected colour's main track + thumbs; rebuild only when the colour changes.
    function renderGallery(force) {
      var color = selected[colorIdx];
      if (!force && color === lastColor) return;
      var imgs = colorImages[color];
      lastColor = color;
      if (!imgs || !imgs.length) return;
      // single-image colour -> hide the redundant thumbnail rail, show the photo on its own
      if (galleryEl) galleryEl.classList.toggle("is-single", imgs.length <= 1);
      if (mainEl) {
        var mh = "";
        for (var i = 0; i < imgs.length; i++) {
          mh += '<img class="pdp__slide" src="' + imgs[i].f + '" alt="' + pTitle + '"' + (i ? ' loading="lazy"' : '') + '>';
        }
        mainEl.innerHTML = mh;
        mainEl.scrollLeft = 0;
        slides = [].slice.call(mainEl.querySelectorAll(".pdp__slide"));
      }
      if (thumbsEl) {
        var th = "";
        for (var i = 0; i < imgs.length; i++) {
          th += '<button type="button" class="' + (i === 0 ? "on" : "") + '" data-idx="' + i + '"><img src="' + imgs[i].t + '" alt="' + pTitle + '" loading="lazy"></button>';
        }
        thumbsEl.innerHTML = th;
      }
    }
    function update() {
      var v = findVariant();
      // reflect selected labels
      root.querySelectorAll("[data-sel]").forEach(function (el) {
        var i = +el.getAttribute("data-sel"); if (selected[i] != null) el.textContent = selected[i];
      });
      // size availability for chosen colour (assumes option 0 colour, 1 size when 2 opts)
      if (optNames.length >= 2) {
        root.querySelectorAll("[data-size]").forEach(function (b) {
          var sizeVal = b.getAttribute("data-size");
          var combo = variants.find(function (vr) { return vr.options[0] === selected[0] && vr.options[1] === sizeVal; });
          var ok = combo && combo.available;
          b.classList.toggle("soldout", !ok);
        });
      }
      if (v && v.available) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = renderPrice(v);
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute("data-label") || "Add to bag"; }
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Sold out"; }
      }
      if (stickyPrice && v) stickyPrice.innerHTML = renderPrice(v);
      if (stickyAdd) { stickyAdd.disabled = !(v && v.available); stickyAdd.textContent = (v && v.available) ? "Add to bag" : "Sold out"; }
      if (saveEl) {
        if (v && v.compare_at_price && v.compare_at_price > v.price) {
          saveEl.textContent = "Save " + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + "%";
          saveEl.hidden = false;
        } else { saveEl.hidden = true; }
      }
      renderGallery();
      updateColorVideo();
    }
    function renderPrice(v) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        return '<span class="now--sale">' + money(v.price) + '</span> <span class="was">' + money(v.compare_at_price) + "</span>";
      }
      return money(v.price);
    }

    root.querySelectorAll("[data-opt]").forEach(function (el) {
      el.addEventListener("click", function () {
        var i = +el.getAttribute("data-opt");
        if (el.classList.contains("soldout")) return;
        selected[i] = el.getAttribute("data-val");
        root.querySelectorAll('[data-opt="' + i + '"]').forEach(function (s) { s.classList.remove("on"); });
        el.classList.add("on");
        update();
      });
    });
    update();
    // pick up the server-rendered slides in case renderGallery had nothing to rebuild
    if (mainEl && !slides.length) slides = [].slice.call(mainEl.querySelectorAll(".pdp__slide"));

    // thumbnails -> scroll the main track to that slide (desktop + tablet)
    if (thumbsEl) {
      thumbsEl.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-idx]");
        if (!btn) return;
        var i = +btn.getAttribute("data-idx");
        if (mainEl && slides[i]) mainEl.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" });
        setActiveThumb(i);
      });
    }

    // swipe the main image on phone -> keep the active thumb in sync
    if (mainEl) {
      var scrollT;
      mainEl.addEventListener("scroll", function () {
        clearTimeout(scrollT);
        scrollT = setTimeout(function () {
          var w = mainEl.clientWidth;
          if (w) setActiveThumb(Math.round(mainEl.scrollLeft / w));
        }, 60);
      }, { passive: true });
    }

    // mobile sticky add bar — appears once the main button scrolls out of view
    if (stickyAdd && addBtn) stickyAdd.addEventListener("click", function () { addBtn.click(); });
    if (stickyBar && addBtn && "IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { stickyBar.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0); });
      }, { threshold: 0 }).observe(addBtn);
    }

    // add to cart (AJAX -> go to cart)
    var form = root.querySelector("form");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Adding…"; }
        cartAdd(+idInput.value, 1)
          .then(function () { if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute("data-label") || "Add to bag"; } })
          .catch(function () { form.submit(); });
      });
    }
  }

  /* ---- cart page ---- */
  function cart() {
    var page = document.querySelector("[data-cart]");
    if (!page) return;
    function change(key, qty) {
      fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function () { window.location.reload(); });
    }
    page.querySelectorAll("[data-remove]").forEach(function (b) {
      b.addEventListener("click", function () { change(b.getAttribute("data-remove"), 0); });
    });
    page.querySelectorAll("[data-qty]").forEach(function (wrap) {
      var key = wrap.getAttribute("data-qty");
      var input = wrap.querySelector("input");
      wrap.querySelectorAll("button").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var v = Math.max(0, (+input.value || 1) + (+btn.getAttribute("data-step")));
          change(key, v);
        });
      });
    });
  }

  /* ---- cart drawer ---- */
  var CD = {};
  function cdInit() {
    CD.drawer = document.querySelector("[data-cart-drawer]");
    if (!CD.drawer) return;
    CD.scrim = document.querySelector("[data-cd-scrim]");
    CD.items = document.querySelector("[data-cd-items]");
    CD.empty = document.querySelector("[data-cd-empty]");
    CD.foot = document.querySelector("[data-cd-foot]");
    CD.count = document.querySelector("[data-cd-count]");
    CD.subtotal = document.querySelector("[data-cd-subtotal]");
    CD.upsell = document.querySelector("[data-cd-upsell]");
    CD.upsellItem = document.querySelector("[data-cd-upsell-item]");
    var close = document.querySelector("[data-cd-close]");
    if (close) close.addEventListener("click", cartClose);
    if (CD.scrim) CD.scrim.addEventListener("click", cartClose);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") cartClose(); });
    document.querySelectorAll(".bag, [data-cart-toggle]").forEach(function (el) {
      el.addEventListener("click", function (e) { e.preventDefault(); cartOpen(); cartRefresh(); });
    });
    if (CD.items) CD.items.addEventListener("click", function (e) {
      var row = e.target.closest(".cd-item"); if (!row) return; var key = row.getAttribute("data-key");
      var step = e.target.closest("[data-cd-step]");
      if (step) { var cur = +row.querySelector(".cd-qty span").textContent || 1; cartChange(key, Math.max(0, cur + (+step.getAttribute("data-cd-step")))); return; }
      if (e.target.closest("[data-cd-remove]")) cartChange(key, 0);
    });
    if (CD.upsellItem) CD.upsellItem.addEventListener("click", function (e) {
      var a = e.target.closest("[data-cd-upsell-add]"); if (a) cartAdd(+a.getAttribute("data-cd-upsell-add"), 1);
    });
    cartRefresh();
  }
  function cartOpen() { if (CD.drawer) { document.body.classList.add("cd-open"); CD.drawer.setAttribute("aria-hidden", "false"); } }
  function cartClose() { document.body.classList.remove("cd-open"); if (CD.drawer) CD.drawer.setAttribute("aria-hidden", "true"); }
  function cartRender(cart) {
    if (!CD.items) return;
    setBag(cart.item_count);
    if (CD.count) CD.count.textContent = cart.item_count ? "(" + cart.item_count + ")" : "";
    if (cart.item_count === 0) {
      CD.items.innerHTML = ""; if (CD.empty) CD.empty.hidden = false; if (CD.foot) CD.foot.hidden = true; if (CD.upsell) CD.upsell.hidden = true; return;
    }
    if (CD.empty) CD.empty.hidden = true; if (CD.foot) CD.foot.hidden = false;
    CD.items.innerHTML = cart.items.map(function (it) {
      var v = (it.variant_title && it.variant_title.indexOf("Default") < 0) ? '<div class="cd-item__v">' + it.variant_title + '</div>' : '';
      var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
      return '<div class="cd-item" data-key="' + it.key + '">'
        + '<a class="cd-item__img" href="' + it.url + '">' + img + '</a>'
        + '<div class="cd-item__body"><div class="cd-item__top"><a class="cd-item__t" href="' + it.url + '">' + it.product_title + '</a><span class="cd-item__price">' + money(it.final_line_price) + '</span></div>' + v
        + '<div class="cd-item__ctrls"><div class="cd-qty"><button type="button" data-cd-step="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-cd-step="1" aria-label="Increase">+</button></div>'
        + '<button type="button" class="cd-item__rm" data-cd-remove>Remove</button></div></div></div>';
    }).join("");
    if (CD.subtotal) CD.subtotal.textContent = money(cart.total_price);
    cartUpsell(cart);
  }
  function cartUpsell(cart) {
    if (!CD.upsell || !CD.upsellItem) return;
    var list = []; try { list = JSON.parse(document.getElementById("CDProducts").textContent); } catch (e) {}
    var inCart = {}; cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var pick = null;
    for (var i = 0; i < list.length; i++) { if (!inCart[list[i].pid]) { pick = list[i]; break; } }
    if (!pick) { CD.upsell.hidden = true; return; }
    CD.upsell.hidden = false;
    CD.upsellItem.innerHTML = '<img src="' + (pick.img || "") + '" alt="">'
      + '<div class="cd__upsell-info"><div class="cd__upsell-t">' + pick.title + '</div><div class="cd__upsell-p">' + pick.price + '</div></div>'
      + '<button type="button" class="cd__upsell-add" data-cd-upsell-add="' + pick.id + '">Add</button>';
  }
  function cartRefresh() { return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { cartRender(c); return c; }); }
  function cartChange(key, qty) {
    return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { cartRender(c); return c; });
  }
  function cartAdd(id, qty) {
    return fetch(addUrl, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
      .then(function (r) { return r.json(); }).then(function () { cartOpen(); return cartRefresh(); });
  }

  /* ---- size guide modal ---- */
  function sizeGuide() {
    var modal = document.querySelector("[data-sizeguide]");
    var openers = document.querySelectorAll("[data-sizeguide-open]");
    if (!modal || !openers.length) return;
    function open() { document.body.classList.add("sg-open"); modal.setAttribute("aria-hidden", "false"); }
    function close() { document.body.classList.remove("sg-open"); modal.setAttribute("aria-hidden", "true"); }
    openers.forEach(function (b) { b.addEventListener("click", open); });
    modal.querySelectorAll("[data-sizeguide-close]").forEach(function (c) { c.addEventListener("click", close); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  /* ---- collection sort ---- */
  function collectionSort() {
    var sel = document.querySelector("[data-sort]");
    if (!sel) return;
    sel.addEventListener("change", function () {
      var url = new URL(window.location.href);
      if (sel.value) { url.searchParams.set("sort_by", sel.value); }
      else { url.searchParams.delete("sort_by"); } // "Featured" -> house order
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  }

  /* ---- written-review carousel (auto-slide + swipe + dots) ---- */
  function revCarousel() {
    document.querySelectorAll("[data-revcards]").forEach(function (root) {
      var track = root.querySelector("[data-revtrack]");
      var dotsWrap = root.querySelector("[data-revdots]");
      if (!track) return;
      var cards = [].slice.call(track.querySelectorAll(".rcard"));
      if (cards.length < 2) { if (dotsWrap) dotsWrap.style.display = "none"; return; }
      var cur = 0, timer = null, dots = [];
      cards.forEach(function (_, i) {
        var d = document.createElement("button");
        d.type = "button"; d.setAttribute("aria-label", "Review " + (i + 1));
        if (i === 0) d.className = "on";
        d.addEventListener("click", function () { go(i); start(); });
        dotsWrap.appendChild(d); dots.push(d);
      });
      function setActive(i) { cur = i; for (var j = 0; j < dots.length; j++) dots[j].classList.toggle("on", j === i); }
      function go(i) { if (i < 0) i = cards.length - 1; if (i >= cards.length) i = 0; track.scrollTo({ left: cards[i].offsetLeft, behavior: "smooth" }); setActive(i); }
      function start() { stop(); timer = setInterval(function () { go(cur + 1); }, 4800); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      var st;
      track.addEventListener("scroll", function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var nearest = 0, best = Infinity;
          for (var j = 0; j < cards.length; j++) { var d = Math.abs(cards[j].offsetLeft - track.scrollLeft); if (d < best) { best = d; nearest = j; } }
          setActive(nearest);
        }, 90);
      }, { passive: true });
      root.addEventListener("mouseenter", stop);
      root.addEventListener("mouseleave", start);
      track.addEventListener("touchstart", stop, { passive: true });
      track.addEventListener("touchend", function () { setTimeout(start, 3500); }, { passive: true });
      var prev = root.querySelector("[data-revprev]"), next = root.querySelector("[data-revnext]");
      if (prev) prev.addEventListener("click", function () { go(cur - 1); start(); });
      if (next) next.addEventListener("click", function () { go(cur + 1); start(); });
      start();
    });
  }

  /* light image protection — block right-click + drag-save on media */
  function protectImages() {
    document.addEventListener("contextmenu", function (e) {
      if (e.target && e.target.closest && e.target.closest("img, picture, video")) e.preventDefault();
    });
    document.addEventListener("dragstart", function (e) {
      if (e.target && e.target.closest && e.target.closest("img, picture, video")) e.preventDefault();
    });
  }

  /* ---- Founding Offer countdown: one fixed shared deadline (epoch from shop time), same for every visitor ---- */
  function foundingCountdown() {
    var els = [].slice.call(document.querySelectorAll("[data-fcd]"));
    if (!els.length) return;
    var timer = null;
    function pad(n) { return n < 10 ? "0" + n : "" + n; }
    function seg(n, l) { return '<span class="fcd__seg"><b>' + pad(n) + '</b><i>' + l + '</i></span>'; }
    function col() { return '<span class="fcd__col">:</span>'; }
    function tick() {
      var now = Date.now();
      var live = false;
      els.forEach(function (el) {
        var end = (+el.getAttribute("data-fcd-end") || 0) * 1000;
        var clock = el.querySelector("[data-fcd-clock]");
        var diff = end - now;
        if (!end || diff <= 0) {
          el.classList.add("is-ended");
          if (el.classList.contains("fcd--bar")) { var bar = el.closest(".anno"); if (bar) bar.hidden = true; }
          else { el.textContent = "Our Anniversary Sale has ended."; }
          return;
        }
        live = true;
        var s = Math.floor(diff / 1000), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), ss = s % 60;
        if (clock) {
          if (el.classList.contains("fcd--pdp")) clock.innerHTML = seg(h, "Hrs") + col() + seg(m, "Min") + col() + seg(ss, "Sec");
          else clock.textContent = pad(h) + ":" + pad(m) + ":" + pad(ss);
        }
      });
      if (!live && timer) clearInterval(timer);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  document.addEventListener("DOMContentLoaded", function () {
    menu(); reveal(); headerScroll(); pdp(); cart(); collectionSort(); cdInit(); sizeGuide(); refreshBag(); revCarousel(); protectImages(); foundingCountdown();
  });
})();
